<template>
  <bar 
    v-if="results.length"
    :chartData="chartData" 
    :options="options" 
    class='bar-chart'
    :height="height"
    ></bar>
</template>

<script>
import bar from "@/components/charts/roundedBarChart/horizontal";
export default {
  components: { bar },
  props: ["results"],
  data() {
    return {
      options: {
        legend: {
          display: false
        },
        scales: {
          xAxes: [{
            ticks: {
              fontColor: "white",
              beginAtZero: true,
              max: 7,
            }
          }],
          yAxes: [
            {
              fontColor: "white",
              display: true,
              ticks: {
                fontColor: "white",
                beginAtZero: true,
                min: 0,
                max: 100,
                stepSize: 20
              }
            }
          ]
        }
      }
    }
  },
  computed: {
    chartData() {
      let colors = ["#c62828", "#0097A7", "#AD1457", "#D84315", "#FFB74D", "#9CCC65", "#4DB6AC", "#4FC3F7", "#90CAF9", "#9575CD", "#6A1B9A", "#BF360C", "#795548", "#E6EE9C", "#00897B", "#29B6F6", "#FF9100", "#1976D2", "#FFFF00", "#00C853", "#00B0FF", "#3D5AFE", "#B388FF", "#795548", "#757575", "#FFCC80", "white", "white", "white", "white", "white", "white", "white", "white" ];
      return {
        labels: this.results.map(d => d.name),
        datasets: [{
          data: this.results.map(d => d.score),
          backgroundColor: colors,
          borderColor: colors,
        }]
      };
    },
    height() {
      if (screen.width < 600) {
        return Math.max(this.results.length * 33, 200);
      }
      return Math.max(this.results.length * 22, 200);
    }
  }
};
</script>